import classNames from 'classnames'
import colors from 'tailwindcss/colors'
import { useThemeContext } from '@/contexts/ThemeContext'
import { ReactFCC } from '@/types/react'

interface Props {
  className?: string
}
export const ExpressGradientWrapper: ReactFCC<Props> = ({ children, className }) => {
  const { isDarkMode } = useThemeContext()
  return (
    <div
      className={classNames('rounded-lg p-[1px]', className)}
      style={{
        background: isDarkMode
          ? 'linear-gradient(156.52deg, rgba(255, 255, 255, 0.3) 2.12%, rgba(255, 255, 255, 0.0001) 39%, rgba(255, 255, 255, 0.0001) 54.33%, rgba(255, 255, 255, 0.1) 93.02%)'
          : colors.gray['200'],
      }}
    >
      {children}
    </div>
  )
}
